/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type BackofficeUserManagementDeleteBackofficeUserMutationVariables =
  Types.Exact<{
    input: Types.BackofficeUserManagementDeleteBackofficeUserInput
  }>

export type BackofficeUserManagementDeleteBackofficeUserMutation = {
  __typename?: 'Mutation'
  backofficeUserManagementDeleteBackofficeUser: string
}

export const BackofficeUserManagementDeleteBackofficeUserDocument = gql`
    mutation BackofficeUserManagementDeleteBackofficeUser($input: BackofficeUserManagementDeleteBackofficeUserInput!) {
  backofficeUserManagementDeleteBackofficeUser(input: $input)
}
    `
export type BackofficeUserManagementDeleteBackofficeUserMutationFn =
  Apollo.MutationFunction<
    BackofficeUserManagementDeleteBackofficeUserMutation,
    BackofficeUserManagementDeleteBackofficeUserMutationVariables
  >

/**
 * __useBackofficeUserManagementDeleteBackofficeUserMutation__
 *
 * To run a mutation, you first call `useBackofficeUserManagementDeleteBackofficeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUserManagementDeleteBackofficeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backofficeUserManagementDeleteBackofficeUserMutation, { data, loading, error }] = useBackofficeUserManagementDeleteBackofficeUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBackofficeUserManagementDeleteBackofficeUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BackofficeUserManagementDeleteBackofficeUserMutation,
    BackofficeUserManagementDeleteBackofficeUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BackofficeUserManagementDeleteBackofficeUserMutation,
    BackofficeUserManagementDeleteBackofficeUserMutationVariables
  >(BackofficeUserManagementDeleteBackofficeUserDocument, options)
}
export type BackofficeUserManagementDeleteBackofficeUserMutationHookResult =
  ReturnType<typeof useBackofficeUserManagementDeleteBackofficeUserMutation>
export type BackofficeUserManagementDeleteBackofficeUserMutationResult =
  Apollo.MutationResult<BackofficeUserManagementDeleteBackofficeUserMutation>
export type BackofficeUserManagementDeleteBackofficeUserMutationOptions =
  Apollo.BaseMutationOptions<
    BackofficeUserManagementDeleteBackofficeUserMutation,
    BackofficeUserManagementDeleteBackofficeUserMutationVariables
  >
